import { Link } from "react-router-dom";
import Tooltip from "./General/Tooltip";
import Badge from "./General/Badge";
import { isFlagEnabled } from "js/utilities";
import { exportPolicies } from "service/policy/exportPolicies";
import EverlakeLoadingOverlay from "./General/EverlakeLoadingOverlay";
import { useState } from "react";
import { useTranslation, Trans } from "react-i18next";

export default function PolicySummaryCard({ data }) {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  async function exportPoliciesToCSV(policyType, policies) {
    setIsLoading(true);

    await exportPolicies(
      policyType,
      policies.map((policy) => policy?.contractID)
    ).catch((error) => {
      console.error("export policies failing", error);
    });

    setIsLoading(false);
  }

  const textTheme =
    data.number > 0 ? "text-theme-text-primary" : "text-theme-text-tertiary";

  return (
    <EverlakeLoadingOverlay
      isLoading={isLoading}
      loadingText={t("PolicySummaryCard-loadingOverlay-loadingText")}
      spinnerSize="md"
    >
      <div className="ui-card relative">
        {data.banner && (
          <div className={`ui-badge-bar ui-badge-bar-${data.banner}`}></div>
        )}
        <div className="p-4 xl:p-6">
          <div className="flex items-center">
            {data.badgeStatus && (
              <span className="mr-2">
                <Badge iconOnly={true} status={data.badgeStatus} />
              </span>
            )}
            <div className={`font-semibold ${textTheme}`}>
              {t("PolicySummaryCard-cardTitle", {
                title: data.title,
              })}
            </div>
            {data?.type === "inactive" && (
              <div className="my-auto self-center">
                <Tooltip
                  srText={t("PolicySummaryCard-tooltip-srText")}
                  content={t("PolicySummaryCard-tooltip-content")}
                />
              </div>
            )}
          </div>
          <div className={`${textTheme}`}>
            <span className={`text-2xl font-semibold mr-2 ${textTheme}`}>
              {t("PolicySummaryCard-cardCount", {
                count: data.number,
              })}
            </span>
            <span className="text-xs">
              {t("PolicySummaryCard-cardsubtitle")}
            </span>
          </div>
          <hr className="my-4" />
          <div
            className={`mt-4 text-right ${data.number ? "" : "hidden"} ${
              data?.exportAction ? "flex gap-3 justify-end" : ""
            }`}
          >
            {isFlagEnabled("ENABLE_EXPORT_LAPSED_POLICIES") &&
              data?.exportAction &&
              data?.number > 0 && (
                <button
                  onClick={() => exportPoliciesToCSV(data.title, data.policies)}
                  className="ui-btn-secondary flex-1"
                >
                  <Trans
                    i18nKey="PolicySummaryCard-exportButton"
                    values={{ title: data.title }}
                    components={{
                      span1: <span className="sr-only" />,
                    }}
                  />
                </button>
              )}
            <Link
              to={`/book-of-business?type=${data.type}`}
              className="ui-btn-primary"
            >
              <Trans
                i18nKey="PolicySummaryCard-linkText"
                values={{ title: data.title }}
                components={{
                  span1: <span className="sr-only" />,
                }}
              />
            </Link>
          </div>
        </div>
      </div>
    </EverlakeLoadingOverlay>
  );
}
